export const thunkResultHandler = (
  action: { meta: { requestStatus: 'fulfilled' | 'rejected' } },
  cb: () => void,
  errCb?: () => void
) => {
  if (action.meta.requestStatus === 'fulfilled') {
    cb();
  } else if (action.meta.requestStatus === 'rejected' && errCb) {
    errCb();
  }
};
